import { Outlet, redirect } from '@tanstack/react-router';

// import { useBeforeUnload } from 'react-use';

// import { Spin } from 'antd';
// import { useEffect, useState } from 'react';
//
// import { dispose, init } from '@/routes/arc/calling/calling.store.tsx';
// import { useConfig } from '@/stores/config.store.ts';
// import { useUser } from '@/stores/user.store.ts';
import { useUserStore } from '@/stores/user.store.ts';

export const Route = createFileRoute({
  component: CallLayout,
  beforeLoad: async () => {
    // check user auth
    const user = useUserStore.getState().user;
    if (!user?.accessToken) {
      return redirect({ to: '/auth/sign-in' });
    }
  },
});
function CallLayout() {
  // useBeforeUnload(
  //   true, // prevent refresh only in prod
  //   'You may lose unsaved work. Are you sure you want to leave?',
  // );
  // const user = useUser()!;
  // const [initialized, setInitialized] = useState(false);
  //
  //
  // if (!initialized) {
  //   return (
  //     <div className={'flex h-full w-full items-center justify-center'}>
  //       <Spin size={'large'} />
  //     </div>
  //   );
  // }

  return (
    <>
      <Outlet />
    </>
  );
}
